var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestForm',{attrs:{"model":_vm.matcherRequest,"submit-button-text":"Anfrage bearbeiten"},on:{"submit":_vm.submit,"favouriteAdded":_vm.addFavourite,"favouriteRemoved":_vm.removeFavourite}})}
var staticRenderFns = []

export { render, staticRenderFns }